import { iEvent, createEvent } from 'modules-core/utility'
import { createSimpleRecord } from 'modules-core/utility/simpleRecord'
import syrinscape from 'app/common/syrinscape'

export interface iMessage {
	message: string
	params?: any
	token?: string
}


export const createPostMessageSystem = () => {
	const onMessage = createSimpleRecord<string, iEvent<iMessage>>(createEvent)
	const onAnyMessage = createEvent<iMessage>()
	window.addEventListener('message', event => {
		let { message, params, token } = event.data as iMessage
		if (token !== syrinscape.config.postMessageToken) {
			return
		}
		let msg = { message, params }
		onAnyMessage.invoke(msg)
		onMessage.getOrUndefined(msg.message)?.invoke(msg)
	})

	return {
		onMessage: (message: string) => onMessage.getOrCreate(message),
		onAnyMessage,
		sendMessage: (message: string, params?: any) => {
			if (!syrinscape.config.postMessageWindow) {
				return
			}
			// params = JSON.parse(JSON.stringify(params))
			let msg = { message, params, token: syrinscape.config.postMessageToken }
			syrinscape.config.postMessageWindow.postMessage(msg, '*')
		}
	}

}

export type iPostMessageSystem = ReturnType<typeof createPostMessageSystem>

export const postMessageSystem = createPostMessageSystem()
export default postMessageSystem
